// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"8519d85b","823":"57cc6b03","837":"104d79e3","870":"c4132f65"}[chunkId] + ".chunk.js";
};